import { Component, Injector, Input } from '@angular/core';
import { BaseFilterComponent } from 'app/core/filter-system';

@Component({
  selector: 'app-sidebar-cashback-shop-category-filter',
  templateUrl: './sidebar-cashback-shop-category-filter.component.html',
  styleUrls: ['./sidebar-cashback-shop-category-filter.component.scss']
})
export class SidebarCashbackShopCategoryFilterComponent extends BaseFilterComponent<string[]> {
  readonly filterId = 'categories';

  @Input() categories: any[] = [];

  categoriesSelection: { [key: string]: boolean } = {};

  constructor(injector: Injector) {
    super(injector);
  }

  getQueryParamKey(): string {
    return 'categories';
  }

  parseQueryParam(rawValue: string): void {
    this.categoriesSelection = {};
    rawValue.split(',').forEach(v => {
      this.categoriesSelection[v] = true;
    });
  }

  buildFilterValue(): string[] {
    const result: string[] = [];
    for (const key in this.categoriesSelection) {
      if (this.categoriesSelection[key]) {
        result.push(key);
      }
    }
    return result;
  }

  clearSelection(): void {
    this.categoriesSelection = {};
  }

  checkCategory(): void {
    this.onFilterChange();
  }
}
